import { render, staticRenderFns } from "./GatewaysList.vue?vue&type=template&id=f6b67146&"
import script from "./GatewaysList.vue?vue&type=script&lang=js&"
export * from "./GatewaysList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports